// extracted by mini-css-extract-plugin
export default {"body":"sprint_body__sF4bW","aside":"sprint_aside__oKZ1m"};